import type { TI_WindowData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTIWindowData: Omit<TI_WindowData, 'selectedVariable'> = {
  title: 'Default Window Title',
  isCollapsable: true,
  value: ''
};
